import { FLEX } from "@/lib/site";
import { cn } from "@/ui/utils/cn";
import { useTranslations } from "@services/strings";
import { Building2, Car, House, Tag } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type Product = "unlock" | "payLess" | "mortgage" | "auto";

/** Each product's icon (the app uses the same ones) and whether it is in the app today. */
export const PRODUCTS: Record<Product, { icon: LucideIcon; live: boolean }> = {
  unlock: { icon: House, live: true },
  payLess: { icon: Tag, live: FLEX.payLessLive },
  // Collects callback requests until the product is in the app.
  mortgage: { icon: Building2, live: false },
  auto: { icon: Car, live: true },
};

/** The product's icon on a tile: mint when it is in the app, grey until then. */
export const ProductIcon = ({
  product,
  className,
}: {
  product: Product;
  className?: string;
}) => {
  const { t } = useTranslations();
  const { icon: Icon, live } = PRODUCTS[product];
  return (
    <span
      className={cn(
        "grid h-10 w-10 shrink-0 place-items-center rounded-xl",
        live ? "bg-mint-soft text-mint-ink" : "bg-mist text-slate-400",
        className,
      )}
    >
      <Icon size={20} aria-hidden="true" />
      <span className="sr-only">
        {t(live ? "site.home.products.live" : "site.home.products.soon")}
      </span>
    </span>
  );
};
